import React from "react";
import Solutions from "../features/solutions/Solutions";
import AnimateSection from "../features/animateSection/AnimateSection";

export default function SolutionsPage({setModalOpen}) { 

    return (
        <AnimateSection>
            <Solutions setModalOpen={setModalOpen} />
        </AnimateSection>
    );
}
